import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const INVITE_BASE = `${API_BASE}/public/stripe-connect/invite`;

/**
 * The invited apartment owner's two calls. Public on purpose — the owner has no Guestbook account
 * and never gets one, so no auth header is sent and the token in the URL is the whole
 * authorisation.
 *
 * Every unusable state (expired, revoked, already connected, never existed) comes back as an
 * identical 404, so there is nothing to branch on beyond "it worked" and "it didn't".
 */

export interface PublicStripeInvite {
  managerName: string;
  apartmentNames: string[];
  paymentMethodName: string;
  maskedEmail: string;
  defaultCountry: string;
  status: 'PENDING' | 'ALREADY_CONNECTED';
}

export async function getPublicStripeInvite(token: string): Promise<PublicStripeInvite> {
  const res = await axios.get(`${INVITE_BASE}/${encodeURIComponent(token)}`);
  return res.data;
}

/** Creates the connected account (lazily, on this first click) and returns a Stripe-hosted
 * onboarding URL to redirect the owner to. */
export async function startStripeInviteOnboarding(
  token: string, country: string,
): Promise<{ url: string }> {
  const res = await axios.post(`${INVITE_BASE}/${encodeURIComponent(token)}/start`, { country });
  return res.data;
}
